import { render, staticRenderFns } from "./ItineraryItem.vue?vue&type=template&id=77e6cfd1&scoped=true&"
import script from "./ItineraryItem.vue?vue&type=script&lang=js&"
export * from "./ItineraryItem.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryItem.vue?vue&type=style&index=0&id=77e6cfd1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e6cfd1",
  null
  
)

export default component.exports